import { toItemCountInputs } from '@/helpers/solarPlant';

/** `ProjectBaseConfigurationInput` from the project's solar plant: the six fields of the block. */
export const toProjectBaseConfigurationInput = (solarPlant) => ({
  solarPanels: toItemCountInputs(solarPlant.solarPanels),
  inverters: toItemCountInputs(solarPlant.inverters),
  batteries: toItemCountInputs(solarPlant.batteries),
  wallboxes: toItemCountInputs(solarPlant.wallboxes),
  energyFlowDirectionSensorItem: solarPlant.energyFlowDirectionSensorItem?._id ?? null,
  emergencyPowerState: solarPlant.emergencyPowerState,
});
